import { cn } from '@rocco/utils/cn';
import { useCallback } from 'react';

interface TagMarkerProps extends React.HTMLAttributes<HTMLDivElement> {
    isApproved: boolean;
    openTag?: () => void;
    isActive?: boolean;
}

const TagMarker = ({
    isApproved,
    openTag,
    isActive,
    ...rest
}: TagMarkerProps) => {
    const handleOpenTag = useCallback(() => {
        if (openTag) {
            openTag();
        }
    }, [openTag]);

    return (
        <div
            className="relative w-8 h-8 -translate-x-1/2 -translate-y-1/2"
            onMouseEnter={handleOpenTag}
            {...rest}
        >
            {/* Wrapper for animated glowing circle */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <div
                    className={cn(
                        'rounded-full opacity-75',
                        isActive ? 'opacity-0' : 'animate-ping w-5 h-5',
                        isApproved ? 'bg-gray-300' : 'bg-brick-300'
                    )}
                ></div>
            </div>

            {/* Main marker */}
            <div
                className={cn(
                    'w-4 h-4 rounded-full bg-gray-50 opacity-85 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-sticky cursor-pointer transition-all duration-300',
                    isActive && 'w-8 h-8 opacity-50',
                    !isApproved && 'bg-brick-500 opacity-100'
                )}
            ></div>
        </div>
    );
};

export default TagMarker;
